import { Box, Typography, Button, TextField, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import infoIcon from '../assets/icons/info.svg';

import { useNavigate } from 'react-router-dom';
import SvgIcon from './SvgIcon';

export type NewPasswordFormProps = {
  onSubmit: (password: string, passwordAgain: string) => void;
};

export default function NewPasswordForm({ onSubmit }: NewPasswordFormProps) {
  const nav = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const [password, setPassword] = useState<string>('');
  const [passwordAgain, setPasswordAgain] = useState<string>('');
  const [formValid, setFormValid] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === 'password') {
      const validatePassword = (newPassword: string) => {
        const regex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%+-.?*]).{8,}$/;

        const isValid = regex.test(newPassword);
        setFormValid(isValid);
      };
      const newPassword = e.target.value;
      setPassword(newPassword);
      validatePassword(newPassword);
    } else {
      setPasswordAgain(e.target.value);
    }
  };

  const handleSubmit = (e: React.SyntheticEvent) => {
    onSubmit(password, passwordAgain);
    e.preventDefault();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Typography sx={{ display: 'flex' }}>
        {t('newPasswordForm.newPasswordLabel')}
      </Typography>
      <TextField
        type="password"
        name="password"
        color="secondary"
        size="small"
        sx={{
          width: '100%',
          backgroundColor: '#FAFAFA',
        }}
        value={password}
        helperText={t('accountForm.passwordRulesInfoText')}
        onChange={handleChange}
        inputProps={{ minLength: 6 }}
        required
      />
      <Typography sx={{ mt: 3, display: 'flex' }}>
        {t('newPasswordForm.newPasswordRetryLabel')}
      </Typography>
      <TextField
        type="password"
        name="passwordAgain"
        color="secondary"
        size="small"
        sx={{
          width: '100%',
          backgroundColor: '#FAFAFA',
        }}
        value={passwordAgain}
        onChange={handleChange}
        inputProps={{ minLength: 6 }}
        required
      />

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          textAlign: 'left',
          alignItems: 'start',
          mt: 2,
          px: 3,
        }}
      >
        <SvgIcon
          src={infoIcon}
          style={{ fill: theme.palette.secondary.main, width: 24 }}
        />
        <Typography
          sx={{ fontSize: 14, ml: 2 }}
          dangerouslySetInnerHTML={{
            __html: t('newPasswordForm.newPasswordAlert'),
          }}
        />
      </Box>

      <Button
        sx={{ mt: 4, width: '100%' }}
        variant="contained"
        type="submit"
        disabled={!formValid}
      >
        {t('newPasswordForm.submit')}
      </Button>
      <Button
        color="secondary"
        sx={{ mt: 3, width: '100%' }}
        variant="contained"
        onClick={() => nav('/login')}
      >
        {t('newPasswordForm.cancel')}
      </Button>
    </form>
  );
}
